import React from "react";
import Styles from './styles.module.scss'
import {useTranslation} from "react-i18next";
import CustomBorder from "../_UI/customBorder";
import {useNavigate} from "react-router-dom";



const ApostolS1 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.pageContainer}`}>
                <div className={`${Styles.titleWrap}`}>
                    <div className={`${Styles.title}`}>{t('Программа “Апостол”')}</div>
                </div>
                <div className={`${Styles.note}`}>{t('Апостол — это партнёрская программа проекта')} <span>TimeCapsule</span>, {t('основанная не только на вознаграждении, но и на идее передачи будущего.')}</div>
                <div className={`${Styles.btnWrap}`}>
                    <CustomBorder corners={{ topRight: true, bottomLeft: true }} fill="#1A1600" borderColor="#FFD700" withHover={true}>
                        <button className={`${Styles.btn}`} onClick={()=>{navigate('/sign-in')}}><div>{t('Стать апостолом')}</div></button>
                    </CustomBorder>
                </div>
            </div>
        </section>
    );
};

export default ApostolS1;